import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "IEC_320_C13",
  "use": "IEC_320_C13-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"IEC_320_C13\"><path d=\"M10 6h20c4.725 2.344 8.058 5.677 10 10v12c-.542 2.437-1.875 4.437-4 6H4c-2.125-1.563-3.458-3.563-4-6V16c1.942-4.323 5.275-7.656 10-10zm8 4v10h4V10h-4zm13 9v10h3V19h-3zM6 19v10h4V19H6z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol